import { render, staticRenderFns } from "./iframePreview.vue?vue&type=template&id=2005df18&scoped=true"
import script from "./iframePreview.vue?vue&type=script&lang=js"
export * from "./iframePreview.vue?vue&type=script&lang=js"
import style0 from "./iframePreview.vue?vue&type=style&index=0&id=2005df18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005df18",
  null
  
)

export default component.exports